module.exports = __webpack_public_path__ + "img/coming.1b359805.jpg";